import React from "react";
import { motion } from "framer-motion";
import { motionProps, titleMain, titleSmall } from "../../animations";

const AnimatedHeadings = ({ smallTitle, mainTitle }) => {
  return (
    <>
      <motion.h5 variants={titleSmall} {...motionProps}>
        {smallTitle}
      </motion.h5>
      <motion.h2 variants={titleMain} {...motionProps}>
        {mainTitle}
      </motion.h2>
    </>
  );
};

export default AnimatedHeadings;
